import { StudentContext } from "./StudentContext";
import { useContext } from "react";

export const useStudentContext = () => {
    const context = useContext(StudentContext);
    if(!context){
        throw Error("useStudentContext should be used inside StudentContextProvidor");
    }
    return context;
}